import { FETCH_CITIES_REQUEST } from './types'
import { takeLatest } from 'redux-saga/effects'
import { fetchCitiesSaga } from './sagas'

// 州情報一覧
export function* watchCitiesSaga() {
  yield takeLatest(FETCH_CITIES_REQUEST, fetchCitiesSaga)
}
